import React, { useState, useEffect } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import AddButton from "@Components/Buttons/AddButton";
import ListingPageTemplate from "@Pages/ListingPageTemplate/ListingPageTemplate";
import themeCreator from "@Themes/themeCreator";
import useDeleteItem from "@Hooks/useDeleteItem";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";
import AssistantPhotoIcon from "@mui/icons-material/AssistantPhoto";
import {
  GET_ORDERS_URL,
  RELEASE_ORDER,
  SAVE_DOCUMENT,
  DELETE_ORDER,
  EXPORT_ORDERS_XSLS,
  PENDING_ORDER_COMMENTS,
  STAR_ORDERS_URL,
  UNSTAR_ORDERS_URL,
  GET_STARRED_ORDERS,
  SET_TO_HAVING_ISSUES,
  SET_AUTOMATIC_STATUS,
} from "@API/APIRoutes";
import { DeletePopup } from "@Components/Popup/DeletePopup";
import { Edit } from "@mui/icons-material";
import PaymentIcon from "@mui/icons-material/Payment";
import NoteAddRoundedIcon from "@mui/icons-material/NoteAddRounded";
import VerifiedIcon from "@mui/icons-material/Verified";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import LockClockRoundedIcon from "@mui/icons-material/LockClockRounded";
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";
import { ThemeProvider } from "@mui/system";
import MeatballsMenu from "@Components/MeatballsMenu/MeatballsMenu";
import usePostItem from "@Hooks/usePostItem";
import useSendPutRequest from "../../Hooks/useSendPutRequest";
import { InsertDocumentPopup } from "../Documents/InsertDocumentPopup";
import { ReleaseOrderPopup } from "../ReleaseOrderPopup/ReleaseOrderPopup";
import { json, useNavigate } from "react-router-dom";
import useSendGetRequest from "../../Hooks/useSendGetRequest";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import axios from "axios";
import usePaginate from "@Hooks/usePaginate";
import {
  getGridStringOperators,
  getGridNumericOperators,
} from "@mui/x-data-grid";
import ChatPopup from "../GenericOrderChat/ChatPopup";
import axiosInstance from "@API/axios";
import { Snackbar, Alert } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { is, ro, tr } from "date-fns/locale";
import StarIcon from "@mui/icons-material/Star";
import { styled } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import {
  Company,
  IncoTerm,
  loadability,
  MaturityType,
  origins,
  Ports,
  State,
  transactionType,
  wayOfShippingOptions,
  approvalStates,
  approvalNames,
  EXPORT_COLUMN_OPTIONS,
} from "../../Utils/HelpingObjects/HelpingObjects";
import { useSelector } from "react-redux";
import GenericFilterForEnums from "../../Components/GenericFillterForEnums/GenericFillterForEnums";
import { castOptionsToFitOptionsFilter } from "../../Utils/Validations/HelperFunctions/FormaterFunctions";
import { encryptId } from "../../Utils/SecurityFunctions";
import { approval } from "../../AppRoutes/DefaultRoutes";
import ExportSelectionPopover from "@Components/ExportSelectionPopover/ExportSelectionPopover";



function GenericOrdersListing(props) {
  const user = useSelector((state) => state.user);
  const theme = themeCreator();
  const dispatch = useDispatch();
  const {
    isReleased,
    title,
    isCanceled,
    readOnly,
    icon: IconComponent,
    showAddOrder = false,
    showAddDocument = false,
    showAddApproval = false,
    showAddInvoice = false,
    showAddCargoX = false,
    showCancelOrder = false,
    showReleaseOrder = false,
    allOrders = false,
    orders_URL = GET_ORDERS_URL + `/${isReleased}/${isCanceled}/${allOrders}`,
    isStarred = false,
  } = props;
  const release_orders_URL = RELEASE_ORDER;
  const error_message = `Failed to Fetch Orders Trying Again!`;
  const [selectedId, setSelectedId] = useState(null);
  const [orderData, setOrderData] = useState(null);
  const { loading: setHavingIssuesLoading, getData: getHavingIssues } =
    useSendGetRequest();
  const {
    loading: setStateAutomaticallyLoading,
    getData: getSetStateAutomatically,
  } = useSendGetRequest();


  const formatDate = (date) => {
    if (!date) return "N/A";

    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? "N/A" : parsed.toLocaleDateString("en-GB");
  };

  const notesForReleaseOrder = [
  {
    label: "BOL Date",
    value: orderData?.bolDate ? formatDate(orderData.bolDate) : "N/A",
  },
  {
    label: "BOL Number",
    value: orderData?.bolNumber || "N/A",
  },
  {
    label: "Expected Arrival Date",
    value: orderData?.expectedArrivalDate ? formatDate(orderData.expectedArrivalDate) : "N/A",
  },
  {
    label: "Invoice Number",
    value: orderData?.invoiceNumber || "N/A",
  },
  {
    label: "Invoice Date",
    value: orderData?.invoiceDate ? formatDate(orderData.invoiceDate) : "N/A",
  },
  {
    label: "Customs Release Date",
    value: orderData?.customsReleaseDate ? formatDate(orderData.customsReleaseDate) : "N/A",  // Note: Fixed typo from "customsreleaseDate" to "customsReleaseDate" to match the data
  },
  {
    label: "Actual Arrival Date",
    value: orderData?.actualArrivalDate ? formatDate(orderData.actualArrivalDate) : "N/A",
  },
  {
    label: "Release Date",
    value: orderData?.releaseDate ? formatDate(orderData.releaseDate) : "N/A",
  },
  {
    label: "Customs Certificate Number",
    value: orderData?.customCertificate || "N/A",
  },
];


  const [exportAnchorPosition, setExportAnchorPosition] = useState(null);
  // Add these state declarations near your other useState declarations:
  const [isDownloading, setIsDownloading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");
  const [isSettingHavingIssues, setIsSettingHavingIssues] = useState(false);
  const navigate = useNavigate();
  const closeExportPopup = () => setExportAnchorPosition(null);
  const openExportPopup = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setExportAnchorPosition({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
    });
  };
  const starPopupLable = isStarred ? "Unstar" : "Star";
  const isExportPopoverOpen = Boolean(exportAnchorPosition);

  //********************* PAGINATION CONTROL *********************//
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const { loading: pageLoading, getPage } = usePaginate();
  const fetchPage = (queryOptions, filterModel) => {
    const storedFilter = sessionStorage.getItem("filterState");
    const parsedFilter = storedFilter ? JSON.parse(storedFilter) : null;
    let filterItems = filterModel.items
      ? [...filterModel.items]
      : parsedFilter?.items
      ? [...parsedFilter.items]
      : [];

    filterItems = filterItems.map((filterItem) => {
      if (filterItem && typeof filterItem.value === "string") {
        return { ...filterItem, value: filterItem.value.trim() };
      }
      return filterItem;
    });

    getPage(
      !isStarred ? orders_URL : GET_STARRED_ORDERS,
      error_message,
      queryOptions,
      filterItems
    ).then((data) => {
      const updatedRows = data.content.map((item) => ({
        ...item,
        materials: (item.materials || [])
          .map((m) => m.materialName?.trim().toUpperCase())
          .join("\u001F"), // ␟ Unit Separator
      }));
      setRows(updatedRows);

      setRowCount(data.totalElements);
    });
  };

  //********************* CANCEL POPUP *********************//
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showStarPopup, setShowStarPopup] = useState(false);

  const { loading: cancelOrderLoading, deleteItem: cancelOrder } =
    useDeleteItem();

  const closeCancelPopup = () => setShowCancelPopup(false);
  const closeStarPopup = () => setShowStarPopup(false);

  const openDeletePopup = (OrderId) => {
    setSelectedId(OrderId);
    setShowCancelPopup(true);
  };
  const openStarPopup = (OrderId) => {
    setSelectedId(OrderId);
    setShowStarPopup(true);
  };

  const confirmCancelCallBack = (canceledOrderId) => {
    setRows((prevData) =>
      prevData.filter((Order) => Order.id !== canceledOrderId)
    );
    closeCancelPopup();
  };
  const confirmUnstarCallBack = () => {
    setRows((prevData) => prevData.filter((Order) => Order.id !== selectedId));
    closeStarPopup();
  };

  const ConfirmStarPopUp = (OrderId) => {
    isStarred
      ? unstarOrder(
          UNSTAR_ORDERS_URL,
          { orderId: OrderId },
          confirmUnstarCallBack,
          `Order Unstarred Successfully!`,
          `Failed to Unstar Order!`
        )
      : starOrder(
          STAR_ORDERS_URL,
          { orderId: OrderId },
          closeStarPopup,
          `Order Starred Successfully!`,
          `Failed to Star Order!`
        );
  };

  const ConfirmCancel = (OrderId) => {
    cancelOrder(
      OrderId,
      confirmCancelCallBack,
      DELETE_ORDER,
      `Order Canceled Successfully!`,
      `Failed to Cancel Order!`
    );
  };

  const handleToggleHavingIssues = (order) => {
    if (!order?.id) {
      return;
    }

    const isCurrentlyHavingIssues = order.state === "HAVING_ISSUES";
    const pendingMessage = isCurrentlyHavingIssues
      ? "Resetting order status..."
      : "Setting to having issues...";

    setIsSettingHavingIssues(true);
    setSnackbarSeverity("info");
    setSnackbarMessage(pendingMessage);
    setOpenSnackbar(true);

    const request = isCurrentlyHavingIssues
      ? getSetStateAutomatically(`${SET_AUTOMATIC_STATUS}/${order.id}`)
      : getHavingIssues(`${SET_TO_HAVING_ISSUES}/${order.id}`);

    request
      .then((response) => {
        const isSuccess = Boolean(response);

        if (!isSuccess) {
          setSnackbarSeverity("error");
          setSnackbarMessage(
            isCurrentlyHavingIssues
              ? "Failed to reset order status."
              : "Failed to set order to having issues."
          );
          setOpenSnackbar(true);
          return;
        }

        const successMessage =
          response?.data?.details ||
          response?.data?.message ||
          (isCurrentlyHavingIssues
            ? "Order status updated automatically."
            : "Order set to having issues.");

        setSnackbarSeverity("success");
        setSnackbarMessage(successMessage);
        setOpenSnackbar(true);

        setRows((prevRows) =>
          prevRows.map((item) => {
            if (item.id !== order.id) return item;

            const nextState = isCurrentlyHavingIssues
              ? response?.data || item.state
              : "HAVING_ISSUES";

            return {
              ...item,
              state: nextState,
            };
          })
        );
      })
      .finally(() => {
        setIsSettingHavingIssues(false);
      });
  };

  const getExportFilterModel = () => {
    if (isReleased) {
      if (allOrders) {
        return JSON.parse(
          sessionStorage.getItem("_all-released-orders_filterState")
        );
      }
      return JSON.parse(sessionStorage.getItem("_released-orders_filterState"));
    }

    if (isCanceled) {
      return JSON.parse(
        sessionStorage.getItem("_all-cancelled-orders_filterState")
      );
    }

    if (allOrders) {
      return JSON.parse(sessionStorage.getItem("_All-pending-orders_filterState"));
    }

    return JSON.parse(sessionStorage.getItem("_my-pending-orders_filterState"));
  };

  const downloadCSV = (selectedColumns) => {
    closeExportPopup();
    // Set downloading state to true to show snackbar
    setIsDownloading(true);

    // Determine the export URL based on the order state
    let exportUrl = EXPORT_ORDERS_XSLS;
    let filterModel;
    if (isReleased) {
      exportUrl = `${EXPORT_ORDERS_XSLS}/released`;
      filterModel = getExportFilterModel();
    } else if (isCanceled) {
      exportUrl = `${EXPORT_ORDERS_XSLS}/cancelled`;
      filterModel = getExportFilterModel();
    } else {
      exportUrl = `${EXPORT_ORDERS_XSLS}/pending`;
      filterModel = getExportFilterModel();
    }
    exportUrl = exportUrl + "/" + allOrders;
    const payload = {
      filtersDto: filterModel?.items || [],
      selectedColumns,
    };

    return axiosInstance
      .post(exportUrl, payload, {
        responseType: "blob",
      })

      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.setAttribute("download", "orders.xlsx");
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        window.URL.revokeObjectURL(url);
        // Set downloading state to false to hide snackbar
        setIsDownloading(false);
      })
      .catch((error) => {
        console.error("Excel download failed:", error);
        // Set downloading state to false in case of error
        setIsDownloading(false);
        setSnackbarMessage("Excel download failed");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      });
  };
  //********************* INSERT DOCUMENT POPUP *********************//
  const [showInsertDocumentPopup, setShowInsertDocumentPopup] = useState(false);
  const { loading: insertDocumentLoading, postItem: insertDocument } =
    usePostItem();

  const { loading: starOrderLoading, postItem: starOrder } = usePostItem();
  const { loading: unstarOrderLoading, postItem: unstarOrder } = usePostItem();

  const closeInsertDocumentPopup = () => setShowInsertDocumentPopup(false);

  const openInsertDocumentPopup = (OrderId) => {
    setSelectedId(OrderId);
    setShowInsertDocumentPopup(true);
  };

  const ConfirmInsertDocument = async (document, file) => {
    const documentData = {
      ...document,
      orderId: selectedId,
      fileAttached: file ? true : false,
    };
    const response = await insertDocument(
      SAVE_DOCUMENT,
      documentData,
      () => {},
      `Document Inserted Successfully!`,
      `Failed to insert Document!`
    );
    if (!response) return;
    if (file) {
      if (!response.preSignedUrl) {
        throw new Error("Presigned URL not received");
      }

      const { preSignedUrl, objectKey } = response;

      // Upload file to Minio
      await axios.put(preSignedUrl, file, {
        headers: {
          "Content-Type": "application/pdf",
        },
      });
    }
    closeInsertDocumentPopup();
  };

  //********************* RELEASE ORDER *********************//

  const [showReleasePopup, setShowReleasePopup] = useState(false);
  const {
    requestMethod: updateData,
    isLoading: releaseOrderLoading,
    isError,
  } = useSendPutRequest(true);

  const closeReleasePopup = () => setShowReleasePopup(false);

  const openReleasePopup = (OrderId) => {
    setSelectedId(OrderId);
    const selectedOrder = rows.find((order) => order.id === OrderId);
    setOrderData(selectedOrder);
    setShowReleasePopup(true);
  };
  const confirmReleaseCallBack = (response, item) => {
    setRows((prevData) => prevData.filter((Order) => Order.id !== item.id));
    closeReleasePopup();
  };
  const ConfirmRelease = async (release) => {
    const releaseData = {
      ...release,
      id: selectedId,
    };
    const response = await updateData(
      release_orders_URL,
      releaseData,
      "Order Released Successfully!"
    );

    if (response) {
      setRows((prevRows) =>
        prevRows.filter((order) => order.id !== releaseData.id)
      );
      closeReleasePopup();
    }
  };
  //********************* CHAT POPUP CONTROL *********************//
  const [isChatOpen, setIsChatOpen] = useState(false);

  const toggleChatPopup = () => {
    setIsChatOpen((prev) => !prev);
  };
  //********************* TABLE PROPS *********************//

  const releaseOption = (id, releasable) => {
    if (releasable) {
      return {
        label: "Release Order",
        icon: <LockOpenRoundedIcon />,
        color: "success",
        action: () => openReleasePopup(id),
        showOption: showReleaseOrder,
      };
    } else {
      return {
        label: "Order Cannot Be Released Waiting For Complete Info",
        icon: <LockClockRoundedIcon />,
        color: "disabled",
        action: null,
        showOption: showReleaseOrder,
      };
    }
  };

  const meatballsMenuOptions = (order) => [
    releaseOption(order.id, order.state === "READY_TO_RELEASE"),
    {
      label: "Add Document",
      icon: <NoteAddRoundedIcon />,
      color: "blue",
      action: () => openInsertDocumentPopup(order.id),
      showOption: showAddDocument,
    },
    {
      label: "Set to Having Issues",
      icon: <AssistantPhotoIcon />,
      color: "error",
      action: () => handleToggleHavingIssues(order),
      showOption: showAddInvoice,
    },
    {
      label: "Add Invoice",
      icon: <PaymentIcon />,
      color: "primary",
      action: () =>
        navigate(
          `${DefaultRoutes.invoice}?orderId=${encryptId(
            order.id
          )}&poNumber=${encryptId(order.poNumber)}`
        ),
      showOption: showAddInvoice,
    },
    {
      label: "Add Approval",
      icon: <VerifiedIcon />,
      color: "primary",
      action: () =>
        navigate(
          DefaultRoutes.approval.replace(":orderId", encryptId(order.id))
        ),
      showOption: showAddApproval,
    },
    {
      label: "Add CargoX",
      icon: <LocalShippingIcon />,
      color: "primary",
      action: () =>
        navigate(DefaultRoutes.cargox.replace(":orderId", encryptId(order.id))),
      showOption: showAddCargoX,
    },
    {
      label: "Cancel Order",
      icon: <CancelRoundedIcon />,
      color: "red",
      action: () => {
        openDeletePopup(order.id);
      },
      showOption: showCancelOrder,
    },
  ];
  const stringCustomOperators = getGridStringOperators().filter((operator) =>
    [
      "contains",
      "doesNotContain",
      "equals",
      "doesNotEqual",
      "startsWith",
      "endsWith",
      "isEmpty",
      "isNotEmpty",
    ]?.includes(operator.value)
  );
  const stringOperatorsWithoutNegative = stringCustomOperators.filter(
    (operator) =>
      operator.value !== "doesNotContain" && operator.value !== "doesNotEqual"
  );

  const numberCustomOperators = getGridNumericOperators().filter((operator) =>
    ["=", "!=", ">", ">=", "<", "<=", "isEmpty", "isNotEmpty"]?.includes(
      operator.value
    )
  );

  const formatState = (state) => {
    if (!state) return "";
    return state
      .toLowerCase() // Convert to lowercase
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
  };

  const columns = [
    {
      field: "pending_chats",
      headerName: "Pending Chats",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "boolean",
      hideable: false,
    },
    {
      field: "currentState",
      headerName: "Status",
      flex: 2.75,
      type: "singleSelect",
      valueOptions: castOptionsToFitOptionsFilter(State),
      filterOperators: GenericFilterForEnums(State),
      hideable: true,
      valueGetter: (params) => formatState(params),
      renderCell: (params) => {
        const isReadyToRelease = params.row.state === "READY_TO_RELEASE";
        return (
          <span
            style={{
              color: isReadyToRelease ? "green" : "grey",
              fontStyle: isReadyToRelease ? "normal" : "italic",
              display: "flex",
              alignItems: "center",
            }}
          >
            {"•"} {formatState(params.row.state)}
          </span>
        );
      },
    },
    {
      field: "poNumber",
      headerName: "PO Number",
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "supplier",
      headerName: "Supplier",
      flex: 2,
      valueGetter: (params) => params?.supplierName,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "planner",
      headerName: "Planner",
      flex: 2,
      valueGetter: (params) => params?.plannerName,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "materials",
      headerName: "Materials",
      flex: 2,
      renderCell: (params) => {
        // Split the tags string back into an array
        const items = params.row.materials.split("\u001F");
        return (
          <TagsContainer>
            {items.map((item, index) => (
              <TagItem key={index}>{item}</TagItem>
            ))}
          </TagsContainer>
        );
      },
      type: "string",
      filterOperators: stringOperatorsWithoutNegative,
      hideable: true,
    },
    {
      field: "agent",
      headerName: "Agent",
      flex: 2,
      valueGetter: (params) => params?.agentName,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "category",
      headerName: "Category",
      flex: 2,
      valueGetter: (params) => params?.categoryName,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "acidNumber",
      headerName: "ACID Number",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "acidCreationDate",
      headerName: "ACID Creation Date",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueFormatter: (params) => formatDate(params),
      hideable: true,
    },
    {
      field: "approval_state",
      headerName: "Approval State",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "singleSelect",
      valueOptions: castOptionsToFitOptionsFilter(approvalStates),
      filterOperators: GenericFilterForEnums(approvalStates),
      hideable: false,
    },
     {
      field: "approval_name",
      headerName: "Approval Name",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "singleSelect",
      valueOptions: castOptionsToFitOptionsFilter(approvalNames),
      filterOperators: GenericFilterForEnums(approvalNames),
      hideable: false,
    },
    {
      field: "form4SendingDate",
      headerName: "Form4 Sent",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueFormatter: (params) => formatDate(params),
      hideable: true,
    },
    {
      field: "form4ReceivalDate",
      headerName: "Form4 Received",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueFormatter: (params) => formatDate(params),
      hideable: true,
    },
    {
      field: "bank",
      headerName: "Bank",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "debitAccount",
      headerName: "Debit Account",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "debitValue",
      headerName: "Debit Value",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: true,
    },
    {
      field: "transactionComments",
      headerName: "Transaction Comments",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },

    {
      field: "maturityType",
      headerName: "Maturity Type",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "singleSelect",
      valueOptions: castOptionsToFitOptionsFilter(MaturityType),
      filterOperators: GenericFilterForEnums(MaturityType),
      hideable: true,
    },
    {
      field: "incoTerm",
      headerName: "Inco Term",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "singleSelect",
      valueOptions: castOptionsToFitOptionsFilter(IncoTerm),
      filterOperators: GenericFilterForEnums(IncoTerm),
      hideable: true,
    },
    {
      field: "maturityDate",
      headerName: "Maturity Date",
      sortable: true,
      filterable: true,
      flex: 2,
      type: "date",
      valueFormatter: (params) => formatDate(params),
      hideable: true,
    },
    {
      field: "paymentDate",
      headerName: "Payment Date",
      sortable: true,
      filterable: true,
      flex: 2,
      type: "date",
      valueFormatter: (params) => formatDate(params),
      hideable: true,
    },
    {
      field: "invoiceNumber",
      headerName: "Invoice Number",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "invoiceAmount",
      headerName: "Invoice Amount",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: true,
    },
    {
      field: "exchangeRate",
      headerName: "Exchange Rate",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: true,
    },
    {
      field: "invoiceCurrency",
      headerName: "Invoice Currency",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "bolNumber",
      headerName: "BOL Number",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "bolDate",
      headerName: "BOL Date",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueFormatter: (params) => formatDate(params),
      hideable: true,
    },
    {
      field: "portOfArrival",
      headerName: "Port of Arrival",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "singleSelect",
      valueOptions: castOptionsToFitOptionsFilter(Ports),
      filterOperators: GenericFilterForEnums(Ports),
      hideable: true,
    },
    {
      field: "shippingLine",
      headerName: "Shipping Line",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      valueGetter: (params) => params?.shippingLineName,
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "shippingPort",
      headerName: "Shipping Port",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "shippedOnboardDate",
      headerName: "Shipped On Board",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueFormatter: (params) => formatDate(params),
      hideable: true,
    },
    {
      field: "releaseDate",
      headerName: "Release Date",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueFormatter: (params) => formatDate(params),
      hideable: true,
    },
    {
      field: "actualArrivalDate",
      headerName: "Actual Arrival",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueFormatter: (params) => formatDate(params),
      hideable: true,
    },
    {
      field: "transactionType",
      headerName: "Transaction Type",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "singleSelect",
      valueOptions: castOptionsToFitOptionsFilter(transactionType),
      filterOperators: GenericFilterForEnums(transactionType),
      hideable: true,
    },
    {
      field: "transactionStatus",
      headerName: "Transaction Status",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "customCertificate",
      headerName: "Customs Certificate",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: true,
    },
    {
      field: "loadability",
      headerName: "loadability",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "singleSelect",
      valueOptions: castOptionsToFitOptionsFilter(loadability),
      filterOperators: GenericFilterForEnums(loadability),
      hideable: true,
    },
    {
      field: "wayOfShipping",
      headerName: "Way Of Shipping",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "singleSelect",
      valueOptions: castOptionsToFitOptionsFilter(wayOfShippingOptions),
      filterOperators: GenericFilterForEnums(wayOfShippingOptions),
      hideable: false,
    },
    {
      field: "hsCode",
      headerName: "HS Code",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "origin",
      headerName: "Origin",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "singleSelect",
      valueOptions: castOptionsToFitOptionsFilter(origins),
      filterOperators: GenericFilterForEnums(origins),
      hideable: false,
    },
    {
      field: "relativeCompany",
      headerName: "Company",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "singleSelect",
      valueOptions: castOptionsToFitOptionsFilter(Company),
      filterOperators: GenericFilterForEnums(Company),
      hideable: false,
    },
    {
      field: "pfiReceivalDate",
      headerName: "PFI Receival Date",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueGetter: (params) => params?.pfiReceivalDate,
      hideable: false,
    },
    {
      field: "grossWeight",
      headerName: "Gross Weight",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: false,
    },
    {
      field: "poAmount",
      headerName: "PO Amount",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: false,
    },
    {
      field: "PendingOn",
      headerName: "Pending On",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "fod",
      headerName: "FOD",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: false,
    },
    {
      field: "poCurrency",
      headerName: "PO Currency",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "maturityPeriod",
      headerName: "Maturity Period",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: true,
    },
    {
      field: "invoiceDate",
      headerName: "Invoice Date",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      // valueGetter: (params) => params?.invoiceDate,
      valueFormatter: (params) => formatDate(params),

    },
    {
      field: "grossWeight",
      headerName: "Gross Weight",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: false,
    },
    {
      field: "netWeight",
      headerName: "Net Weight",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: false,
    },
    {
      field: "container20",
      headerName: "20ft Containers",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: false,
    },
    {
      field: "container40",
      headerName: "40ft Containers",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: false,
    },
    {
      field: "pallets",
      headerName: "Pallets",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: false,
    },
    {
      field: "boxes",
      headerName: "Boxes",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: false,
    },
    {
      field: "bookingNumber",
      headerName: "Booking Number",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "expectedArrivalDate",
      headerName: "Expected Arrival",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueGetter: (params) => params?.expectedArrivalDate,
      hideable: false,
    },
    {
      field: "customsApprovalDate",
      headerName: "Customs Approval",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueGetter: (params) => params?.customsApprovalDate,
      hideable: false,
    },
    {
      field: "customsReleaseDate",
      headerName: "Customs Released",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueGetter: (params) => params?.customsReleaseDate,
      hideable: false,
    },
    {
      field: "storageLocation",
      headerName: "Storage Location",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "warehouse",
      headerName: "Warehouse",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "warehouseArrivalDate",
      headerName: "Warehouse Arrival",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueGetter: (params) => params?.warehouseArrivalDate,
      hideable: false,
    },
    {
      field: "ibdNumber",
      headerName: "IBD Number",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "ibdDate",
      headerName: "IBD Date",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueGetter: (params) => params?.ibdDate,
      hideable: false,
    },
    {
      field: "authorizationDate",
      headerName: "Authorization Date",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueFormatter: (params) => formatDate(params),
      hideable: true,
    },
    {
      field: "expectedReleaseDate",
      headerName: "Expected Release Date",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      hideable: false,
    },
    {
      field: "storageDate",
      headerName: "Storage Date",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      hideable: false,
    },
    {
      field: "bankLinkage",
      headerName: "Bank Linkage",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "nonRelevant",
      headerName: "Non Relevant",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "shippingCountry",
      headerName: "Shipping Country",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "generalComment",
      headerName: "General Comment",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "drums",
      headerName: "Drums",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "number",
      filterOperators: numberCustomOperators,
      hideable: false,
    },
    {
      field: "isSample",
      headerName: "Is Sample",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "boolean",
      hideable: false,
    },
    {
      field: "orderNumber",
      headerName: "Order Number",
      sortable: false,
      filterable: true,
      flex: 0,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: false,
    },
    {
      field: "idcNumber",
      headerName: "IDC Number",
      sortable: false,
      filterable: true,
      flex: 0,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "uploadOnPortalDate",
      headerName: "Upload On Portal Date",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "date",
      valueFormatter: (params) => formatDate(params),
      hideable: true,
    },
    {
      field: "proceededManually",
      headerName: "Proceeded Manually",
      sortable: false,
      filterable: true,
      flex: 2,
      type: "boolean",
      hideable: true,
    },
    {
      field: "coraId",
      headerName: "CORA ID",
      sortable: false,
      filterable: true,
      flex: 0,
      type: "string",
      filterOperators: stringCustomOperators,
      hideable: true,
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      flex: 2.5,
      hideable: false,
      renderCell: (params) => (
        <ThemeProvider theme={theme}>
          {!readOnly ? (
            <Tooltip title="Actions">
              <MeatballsMenu options={meatballsMenuOptions(params.row)} />
            </Tooltip>
          ) : null}

          <Tooltip title="Preview Order">
            <IconButton
              color="info"
              onClick={() => {
                if (
                  allOrders &&
                  !user.roles?.includes("PLANNING_MANAGER") &&
                  !user.roles?.includes("PLANNER") &&
                  !user.roles?.includes("WAREHOUSE_MEMBER") &&
                  !user.roles?.includes("QUALITY_MEMBER") &&
                  !user.roles?.includes("TRANSPORTATION_COORDINATOR") &&
                  !user.roles?.includes("TREASURY_COORDINATOR") &&
                  !user.roles?.includes("EXTERNAL_TREASURY_COORDINATOR")
                ) {
                  navigate(
                    DefaultRoutes.otherOrderInfo.replace(
                      ":orderId",
                      encryptId(params.row.id)
                    )
                  );
                } else {
                  navigate(
                    DefaultRoutes.orderInfo.replace(
                      ":orderId",
                      encryptId(params.row.id)
                    )
                  );
                }
              }}
              size="small"
            >
              <InfoRoundedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Add Comment">
            <IconButton
              color="info"
              size="small"
              onClick={() => {
                setSelectedId(params.row.id); // store this order's ID
                // Set both groupChatPending and plannerChatPending to false for this order
                setRows((prevRows) =>
                  prevRows.map((order) =>
                    order.id === params.row.id
                      ? {
                          ...order,
                          pendingChatResponse: order.pendingChatResponse
                            ? {
                                ...order.pendingChatResponse,
                                groupChatPending: false,
                                plannerChatPending: false,
                              }
                            : false,
                        }
                      : order
                  )
                );
                toggleChatPopup(); // open the chat popup
              }}
              sx={{ position: "relative" }}
            >
              <CommentRoundedIcon />
              {(() => {
                const orderChat = params.row?.pendingChatResponse;

                // If we have pending chats, show dots
                if (orderChat) {
                  return (
                    <>
                      {/* First dot - show if first boolean is true */}
                      {orderChat.groupChatPending && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: 2,
                            right: 2,
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor: "error.main",
                            border: "1px solid white",
                          }}
                        />
                      )}

                      {/* Second dot - show if second boolean is true */}
                      {orderChat.plannerChatPending && (
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: 2,
                            right: 2,
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: "error.main",
                            border: "1px solid white",
                          }}
                        />
                      )}
                    </>
                  );
                }
                return null;
              })()}
            </IconButton>
          </Tooltip>
          {!isStarred && !allOrders && !isCanceled && !isReleased && (
            <Tooltip title="Star Order">
              <IconButton
                color="info"
                onClick={() => {
                  openStarPopup(params.row.id);
                }}
                size="small"
              >
                <StarIcon color="yellow" />
              </IconButton>
            </Tooltip>
          )}
          {isStarred && (
            <Tooltip title="unStar Order">
              <IconButton
                color="info"
                onClick={() => {
                  openStarPopup(params.row.id);
                }}
                size="small"
              >
                <StarIcon color="red" />
              </IconButton>
            </Tooltip>
          )}
        </ThemeProvider>
      ),
    },
  ];
  const initialColumnVisibilityModel = {
    agent: true,
    category: true,
    state: !readOnly,
    shippedOnboardDate: false,
    wayOfShipping: false,
    pfiReceivalDate: false,
    acidNumber: false,
    hsCode: false,
    origin: false,
    relativeCompany: false,
    acidCreationDate: false,
    form4SendingDate: false,
    form4ReceivalDate: false,
    bank: false,
    incoTerm: false,
    poAmount: false,
    PendingOn: false,
    fod: false,
    poCurrency: false,
    maturityType: false,
    maturityPeriod: false,
    maturityDate: false,
    invoiceDate: false,
    invoiceNumber: false,
    invoiceAmount: false,
    invoiceCurrency: false,
    grossWeight: false,
    netWeight: false,
    bolNumber: false,
    bolDate: false,
    portOfArrival: false,
    shippingLine: false,
    container20: false,
    container40: false,
    pallets: false,
    boxes: false,
    bookingNumber: false,
    shippingPort: false,
    releaseDate: false,
    expectedArrivalDate: false,
    actualArrivalDate: false,
    customsApprovalDate: false,
    customCertificate: false,
    customsReleaseDate: false,
    storageLocation: false,
    warehouse: false,
    warehouseArrivalDate: false,
    ibdNumber: false,
    ibdDate: false,
    transactionType: false,
    authorizationDate: false,
    expectedReleaseDate: false,
    bankLinkage: false,
    nonRelevant: false,
    shippingCountry: false,
    loadability: false,
    generalComment: false,
    drums: false,
    isSample: false,
    storageDate: false,
    pending_chats: false,
    approval_state: false,
    approval_name: false,
    orderNumber: false,
    idcNumber: false,
    uploadOnPortalDate: false,
    proceededManually: false,
    coraId: false,
    debitAccount: false,
    debitValue: false,
    transactionComments: false,
    exchangeRate: false,
    paymentDate: false,
    transactionStatus: false,
  };

  const OrdersTableProps = {
    columns,
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    initialColumnVisibilityModel,
    rowCount,
    rows,
    isLoading: pageLoading,
    fetchPage,
    exportUrl: EXPORT_ORDERS_XSLS,
    exportOnClick: openExportPopup,
    sortBy: "orderId",
  };

  const handleAddOrderButton = () => {
    navigate(DefaultRoutes.addneworders);
  };

  //********************* RETURN *********************//
  return (
    <Box>
      <ListingPageTemplate
        title={title}
        PageIcon={<IconComponent color="white" fontSize="large" />}
        iconColor={theme.palette.primary.main}
        buttons={[
          showAddOrder ? (
            <AddButton
              key="add-button"
              ButtonText={`Add Order`}
              onClick={handleAddOrderButton}
            />
          ) : null,
        ]}
        tableProps={OrdersTableProps}
        serverPagination={true}
      />
      <ChatPopup
        open={isChatOpen}
        onClose={toggleChatPopup}
        orderId={selectedId}
      />
      <ExportSelectionPopover
        open={isExportPopoverOpen}
        anchorPosition={exportAnchorPosition}
        onClose={closeExportPopup}
        onExport={downloadCSV}
        columnOptions={EXPORT_COLUMN_OPTIONS}
        description="Choose which columns to include in the Excel export."
      />
      <Snackbar
        open={isDownloading || openSnackbar}
        autoHideDuration={openSnackbar && !isSettingHavingIssues ? 6000 : null}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          severity={isDownloading ? "info" : snackbarSeverity}
          onClose={() => (isDownloading ? null : setOpenSnackbar(false))}
        >
          {isDownloading ? "Downloading Excel..." : snackbarMessage}
        </Alert>
      </Snackbar>
      {!readOnly ? (
        <>
          {DeletePopup(
            "Order",
            showCancelPopup,
            closeCancelPopup,
            ConfirmCancel,
            selectedId,
            cancelOrderLoading,
            "Cancel"
          )}
          <InsertDocumentPopup
            showPopup={showInsertDocumentPopup}
            closePopup={closeInsertDocumentPopup}
            Confirm={ConfirmInsertDocument}
            loading={insertDocumentLoading}
            documentData={null}
            isEditing={false}
            selectedId={selectedId}
          />
          {ReleaseOrderPopup(
            showReleasePopup,
            closeReleasePopup,
            ConfirmRelease,
            releaseOrderLoading,
            notesForReleaseOrder
          )}
        </>
      ) : null}
      {DeletePopup(
        "Order",
        showStarPopup,
        closeStarPopup,
        ConfirmStarPopUp,
        selectedId,
        isStarred ? unstarOrderLoading : starOrderLoading,
        starPopupLable
      )}
    </Box>
  );
}

export default GenericOrdersListing;

export const TagsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5), // smaller spacing between tags
  maxWidth: "100%",
  overflowX: "auto",
  whiteSpace: "nowrap",
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(0.25, 0), // less vertical padding

  // Hide scrollbars
  "&::-webkit-scrollbar": {
    height: 0,
  },
  scrollbarWidth: "none",
  msOverflowStyle: "none",
}));

export const TagItem = styled("div")(({ theme }) => ({
  padding: theme.spacing(0.25, 0.75), // more compact tags
  borderRadius: theme.spacing(2),
  backgroundColor: theme.palette.grey[400],
  color: "black",
  fontSize: ".9rem", // smaller text
  fontWeight: 500,
  whiteSpace: "nowrap",
  display: "inline-block",
  lineHeight: 1.2,
  marginTop: ".8rem",
}));
